import { stageMenuStore } from './store.js';
import { templateStore } from '../../template/index.js';

/**
 * Render recipe list for a category field using EJS templates
 * @param {HTMLElement} container - Container element for the category
 * @param {string} fieldName - ACF field name (e.g., day_1_cat_5)
 */
export function displayFieldList(container, fieldName) {
	const recipes = stageMenuStore.getRecipesByField(fieldName);
	const template = templateStore.get('stage/recipe/item.ejs');
	const emptyTemplate = templateStore.get('stage/recipe/empty.ejs');
	const listTitleTemplate = templateStore.get('stage/recipe/list-title.ejs');

	if (!recipes.length) {
		// eslint-disable-next-line no-undef
		container.innerHTML = ejs.render(emptyTemplate, { menuDay: fieldName }) || '';
		return;
	}

	// eslint-disable-next-line no-undef
	let html = ejs.render(listTitleTemplate, { count: recipes.length, menuDay: fieldName }) || '';

	recipes.forEach(recipe => {
		// eslint-disable-next-line no-undef
		html += ejs.render(template, { recipe });
	});

	container.innerHTML = html;
}

/**
 * Update the recipe count badge on the "Recettes" tab button
 */
export function updateRecipeCounter() {
	const counter = document.querySelector('.edit-stage-tab-btn[data-tab="recipe"] .indicator');
	if (counter) {
		counter.textContent = stageMenuStore.getTotalRecipeCount();
	}
}

/**
 * Trigger reload for a specific day
 * Dispatches 'stage-menu-reload' custom event
 * @param {number} day - Day number to reload
 */
export function triggerStageMenuReload(day) {
	document.dispatchEvent(new CustomEvent('stage-menu-reload', { detail: { day } }));
}
